/*!
 * @monogrid/vue-boost v8.0.1 Copyright (C) MONOGRID S.R.L. - All Rights Reserved - Unauthorized copying of this file, via any medium is strictly prohibited
 */
const s = (t, e) => {
  const o = t.__vccOpts || t;
  for (const [r, c] of e)
    o[r] = c;
  return o;
};
export {
  s as default
};
